import React from "react";

import makeStyles from '@mui/styles/makeStyles';
import Fab from "@mui/material/Fab";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";

import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
}));

export const SearchLoader = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Fab aria-label="save" color="primary">
        <SearchIcon />
      </Fab>
      <CircularProgress size={68} className={classes.fabProgress} />
    </div>
  );
};
